module.exports = __webpack_public_path__ + "img/DSR.3578b38e.png";